import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';

import { UsuarioService } from '../../services/shared/usuario.service';
import { SignoPlanService } from '../../services/entidades/signo-planes.service';
import { MatDialog } from '@angular/material/dialog';
import { PushPreviewDialogComponent } from './push-preview-dialog.component';
import { PushDevicesDialogComponent } from './push-devices-dialog/push-devices-dialog.component';
import { PushFrontService } from '../../services/push/push-front.service';

@Component({
    selector: 'app-push',
    templateUrl: './push.component.html',
    styleUrls: ['./push.component.scss'],
})
export class PushComponent implements OnInit {
    @ViewChild('titleInput') titleInput!: ElementRef<HTMLInputElement>;
    @ViewChild('bodyInput') bodyInput!: ElementRef<HTMLTextAreaElement>;

    // Mensaje
    title = '📲 BENEFICIOS';
    body = 'Mensaje de prueba para la app 🚀';
    token = '';

    // Estado
    loading = false;
    loadingSearchUser = false;
    loadingSending = false;
    loadingSendingText = '';

    // Progreso dinámico de envío
    sendingProgress = 0;
    sendingProcessed = 0;
    sendingTotal = 0;
    private progressInterval: any = null;

    // Usuarios
    usuarios: any[] = [];
    cols = ['nombre', 'email', 'accion'];

    // Planes
    planes: any[] = [];
    planSeleccionado: string | null = null;

    // Plan → tabla con filtro
    filtroPlan = '';
    dataSourcePlan = new MatTableDataSource<any>([]);

    // Métricas Plan
    totalPlan = 0;
    totalConPush = 0;
    totalIOS = 0;
    totalAndroid = 0;

    // Métricas Masivo
    totalMasivo = 0;
    totalConPushMasivo = 0;
    totalSinPushMasivo = 0;
    loadingMasivo = false;

    searchTerm = '';

    constructor(
        private pushService: PushFrontService,
        private usuariosService: UsuarioService,
        private signoPlanService: SignoPlanService,
        private snack: MatSnackBar,
        private dialog: MatDialog,
    ) {}

    async ngOnInit() {
        try {
            const list = await this.signoPlanService.getPlanes();
            this.planes = [
                { _id: 'todos', denominacion: '🌟 Todos los Planes (Todos los Afiliados)' },
                ...(list || [])
            ];
        } catch {
            this.planes = [{ _id: 'todos', denominacion: '🌟 Todos los Planes (Todos los Afiliados)' }];
        }

        this.cargarMetricasMasivas();

        this.dataSourcePlan.filterPredicate = (u: any, filter: string) => {
            const f = filter.trim().toLowerCase();
            const nombre =
                `${u.nombrePersona || ''} ${u.apellidoPersona || ''}`.toLowerCase();
            const email = (u.email || '').toLowerCase();
            return nombre.includes(f) || email.includes(f);
        };
    }

    async cargarMetricasMasivas() {
        this.loadingMasivo = true;
        try {
            const res = await this.pushService.getMasivoEstimacion();
            const data = res?.response || res || {};
            this.totalMasivo = data.destinatariosTotales || 0;
            this.totalConPushMasivo = data.conPush || 0;
            this.totalSinPushMasivo = data.sinPush || 0;
        } catch (e) {
            console.error('Error cargando métricas masivas:', e);
        } finally {
            this.loadingMasivo = false;
        }
    }

    /* ================= TEXTO ================= */
    private insertText(
        el: HTMLInputElement | HTMLTextAreaElement | null,
        current: string,
        set: (v: string) => void,
        text: string,
    ) {
        if (!el) {
            set(current + text);
            return;
        }

        const start = el.selectionStart ?? current.length;
        const end = el.selectionEnd ?? current.length;

        set(current.slice(0, start) + text + current.slice(end));

        setTimeout(() => {
            el.focus();
            el.setSelectionRange(start + text.length, start + text.length);
        });
    }

    insertIntoTitle(t: string) {
        this.insertText(
            this.titleInput?.nativeElement,
            this.title,
            (v) => (this.title = v),
            t,
        );
    }

    insertIntoBody(t: string) {
        this.insertText(
            this.bodyInput?.nativeElement,
            this.body,
            (v) => (this.body = v),
            t,
        );
    }

    clearTitle() {
        this.title = '';
        this.titleInput?.nativeElement?.focus();
    }

    clearBody() {
        this.body = '';
        this.bodyInput?.nativeElement?.focus();
    }

    /* ================= PLAN ================= */
    async buscarUsuariosPorPlan() {
        if (!this.planSeleccionado) return;

        this.loading = true;
        this.dataSourcePlan.data = [];
        this.filtroPlan = '';

        this.totalPlan = 0;
        this.totalConPush = 0;
        this.totalIOS = 0;
        this.totalAndroid = 0;

        try {
            const resp = await this.usuariosService.getUsuariosPorPlan(
                this.planSeleccionado,
            );
            const lista = (resp as any)?.response ?? resp ?? [];

            this.totalPlan = lista.length;
            this.totalConPush = lista.filter((u: any) => !!u.pushToken).length;
            this.totalIOS = lista.filter(
                (u: any) => u.pushToken && u.pushPlatform === 'ios',
            ).length;
            this.totalAndroid = lista.filter(
                (u: any) => u.pushToken && u.pushPlatform === 'android',
            ).length;

            this.dataSourcePlan.data = lista.sort((a: any, b: any) => {
                if (a.pushToken && !b.pushToken) return -1;
                if (!a.pushToken && b.pushToken) return 1;
                return 0;
            });
        } finally {
            this.loading = false;
        }
    }

    aplicarFiltroPlan(value: string) {
        this.filtroPlan = value;
        this.dataSourcePlan.filter = value.trim().toLowerCase();
    }

    limpiarFiltroPlan() {
        this.aplicarFiltroPlan('');
    }

    verDestinatariosPlan(tipo: 'todos' | 'push' | 'ios' | 'android') {
        if (!this.dataSourcePlan.data || !this.dataSourcePlan.data.length) return;

        let titulo = '👥 Afiliados del Plan';
        if (tipo === 'push') titulo = '📱 Afiliados Habilitados con Push';
        if (tipo === 'ios') titulo = '🍎 Afiliados con Dispositivo iOS';
        if (tipo === 'android') titulo = '🤖 Afiliados con Dispositivo Android';

        this.dialog.open(PushDevicesDialogComponent, {
            width: '750px',
            maxHeight: '90vh',
            data: {
                users: this.dataSourcePlan.data,
                tipo,
                title: titulo,
            },
        });
    }

    /* ================= ENVÍOS ================= */
    async enviarPorToken() {
        if (!this.token) return;
        await this.enviar({ token: this.token });
    }

    async enviarAUsuario(u: any) {
        await this.confirmarEnvio(() =>
            this.enviar({ token: u.pushToken || '', usuario: u._id }),
        );
    }

    async enviar(extra: any) {
        this.loadingSending = true;
        this.loadingSendingText = 'Enviando comunicación al afiliado... Por favor espere.';

        try {
            const resp: any = await this.pushService.sendPustToken({
                title: this.title,
                body: this.body,
                ...extra,
            });

            if (resp?.ok === false) {
                let mensajeUI = resp.message || 'Error enviando push';

                if (resp.errorCode === 'TOKEN_INVALID') {
                    mensajeUI =
                        '⚠️ El dispositivo ya no está registrado (token inválido). Se depositó el mensaje interno.';
                }

                this.snack.open(mensajeUI, 'Cerrar', {
                    duration: 5000,
                    panelClass: 'snack-error',
                });

                return;
            }

            this.snack.open('Notificación / Mensaje enviado 🚀', 'OK', {
                duration: 3000,
            });
        } catch (error) {
            this.snack.open('Error inesperado del servidor', 'Cerrar', {
                duration: 5000,
                panelClass: 'snack-error',
            });
        } finally {
            this.loadingSending = false;
        }
    }

    private iniciarProgreso(total: number, velocidadPorSegundo: number = 220) {
        this.sendingTotal = total;
        this.sendingProcessed = 0;
        this.sendingProgress = 0;

        if (this.progressInterval) {
            clearInterval(this.progressInterval);
        }

        const intervalMs = 120;
        const stepAmount = Math.max(1, Math.round((velocidadPorSegundo * intervalMs) / 1000));

        this.progressInterval = setInterval(() => {
            if (this.sendingProcessed < total) {
                const limite95 = Math.floor(total * 0.95);
                if (this.sendingProcessed < limite95) {
                    this.sendingProcessed = Math.min(limite95, this.sendingProcessed + stepAmount);
                } else if (this.sendingProcessed < total - 1) {
                    this.sendingProcessed += 1;
                }
                this.sendingProgress = Math.min(99, Math.round((this.sendingProcessed / total) * 100));
            }
        }, intervalMs);
    }

    private finalizarProgreso() {
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
            this.progressInterval = null;
        }
        if (this.sendingTotal > 0) {
            this.sendingProcessed = this.sendingTotal;
            this.sendingProgress = 100;
        }
    }

    async enviarPushPorPlan() {
        if (!this.planSeleccionado || this.totalPlan === 0) return;

        await this.confirmarEnvio(async () => {
            this.loadingSending = true;
            this.iniciarProgreso(this.totalPlan);
            this.loadingSendingText = `Procesando envío por plan a ${this.totalPlan} afiliados (${this.totalConPush} con Push y ${this.totalPlan - this.totalConPush} mensaje interno). Por favor espere...`;

            try {
                const resp = await this.pushService.sendPushPorPlan({
                    title: this.title,
                    body: this.body,
                    planId: this.planSeleccionado!,
                });

                this.finalizarProgreso();
                const r = (resp as any)?.response || resp;
                const totalNotificados = r?.totalNotificados || r?.totalTokens || this.totalPlan;
                this.snack.open(
                    `📢 Notificación enviada a ${totalNotificados} afiliados`,
                    'OK',
                    { duration: 4000 },
                );
            } catch (error) {
                this.snack.open('Error procesando el envío por plan', 'Cerrar', {
                    duration: 5000,
                    panelClass: 'snack-error',
                });
            } finally {
                setTimeout(() => {
                    this.loadingSending = false;
                    this.sendingProgress = 0;
                    this.sendingTotal = 0;
                    this.sendingProcessed = 0;
                }, 600);
            }
        }, this.totalPlan);
    }

    async enviarATodos() {
        await this.confirmarEnvio(async () => {
            this.loadingSending = true;
            this.iniciarProgreso(this.totalMasivo);
            this.loadingSendingText = `Procesando envío masivo a ${this.totalMasivo} afiliados (${this.totalConPushMasivo} con Push y ${this.totalSinPushMasivo} mensaje interno). Esto puede demorar unos segundos...`;

            try {
                const resp: any = await this.pushService.sendPushMasivo({
                    title: this.title,
                    body: this.body,
                });

                this.finalizarProgreso();
                const r = resp?.response || resp;
                const totalU = r?.totalUsuarios || this.totalMasivo || 0;
                const pushOk = r?.successCount ?? 0;
                const sinP = r?.sinPushCount ?? (totalU - pushOk);

                this.snack.open(
                    `📢 Envíos Masivos completado: Notificados ${totalU} afiliados (${pushOk} Push entregados, ${sinP} Mensaje Interno en buzón)`,
                    'OK',
                    { duration: 6000 },
                );
            } catch (error) {
                this.snack.open('Error procesando el envío masivo', 'Cerrar', {
                    duration: 5000,
                    panelClass: 'snack-error',
                });
            } finally {
                setTimeout(() => {
                    this.loadingSending = false;
                    this.sendingProgress = 0;
                    this.sendingTotal = 0;
                    this.sendingProcessed = 0;
                }, 600);
            }
        });
    }

    async buscarUsuarios() {
        if (!this.searchTerm || this.searchTerm.length < 2) return;

        this.loadingSearchUser = true;
        try {
            const data = await this.usuariosService.getAllUsersGrilla();
            const q = this.searchTerm.toLowerCase();

            this.usuarios = (data || [])
                .filter((u: any) => {
                    return (
                        (u.nombrePersona || '').toLowerCase().includes(q) ||
                        (u.apellidoPersona || '').toLowerCase().includes(q) ||
                        (u.email || '').toLowerCase().includes(q)
                    );
                })
                .sort((a: any, b: any) => {
                    if (a.pushToken && !b.pushToken) return -1;
                    if (!a.pushToken && b.pushToken) return 1;
                    return 0;
                });
        } catch (error) {
            console.error('Error buscando usuarios:', error);
        } finally {
            this.loadingSearchUser = false;
        }
    }

    async confirmarEnvio(accion: () => Promise<void>, cantidad?: number) {
        const ref = this.dialog.open(PushPreviewDialogComponent, {
            width: '360px',
            data: {
                title: this.title,
                body: this.body,
                cantidad,
            },
        });

        const ok = await ref.afterClosed().toPromise();
        if (ok) {
            await accion();
        }
    }
}
